import { render } from "./AppointmentRegionList.vue?vue&type=template&id=de555632&scoped=true&ts=true"
import script from "./AppointmentRegionList.ts?vue&type=script&lang=ts"
export * from "./AppointmentRegionList.ts?vue&type=script&lang=ts"

import "./AppointmentRegionList.scss?vue&type=style&index=0&id=de555632&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de555632"]])

export default __exports__